export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/f9541d360f96791aa3f0dd381d4000ad.png";